/* eslint-disable tailwindcss/no-custom-classname */
import { useState, useEffect } from 'react'
import { SummaryDetail } from '@/types/summary'
import { Reason } from '@/types/user'
import { Property } from './'
import { ReadButton, ShopList } from './SubMenu'
import { VoiceModal } from './Voice'
import { useUser } from '@/hooks/useUser'
import { useRouter } from 'next/router'

interface Props {
  summary: SummaryDetail
  reason?: number
}
export const InfoSp: React.FC<Props> = ({
  summary,
  reason = Reason.CAN_NOT_READABLE,
}) => {
  const user = useUser()
  const [open, setOpen] = useState(false)
  const [openVoice, setOpenVoice] = useState(false)
  const router = useRouter()
  useEffect(() => {
    setOpen(false)
  }, [router])
  return (
    <div className="px-[10px] mb-[30px] sp">
      {open ? (
        <Property summary={summary} onClick={() => setOpen(false)} />
      ) : (
        <div className="relative pb-[10px] align-top">
          <div
            className="after:absolute after:top-[3px] after:right-[10px] after:text-4xl after:leading-4 after:text-[#50608b] after:content-['+']"
            onClick={() => setOpen(true)}
          >
            書籍情報を見る
          </div>
        </div>
      )}
      <div className="border-t border-b border-gray-200">
        <ShopList shops={summary.shops} />
      </div>
      {reason == Reason.READABLE && user?.result && summary?.voice !== '' && (
        <div className="overflow-hidden p-[10px] w-full bg-[#f5f5f5] border-2 border-[#e6e6e6] border-solid">
          <ReadButton
            type="voice"
            onClick={() => setOpenVoice(true)}
            isThemselves={summary.id == 1594}
          />
          <VoiceModal
            isOpen={openVoice}
            summaryId={summary?.id}
            image={summary?.image}
            title={summary?.title}
            voice={summary?.voice}
            onClose={() => setOpenVoice(false)}
          />
        </div>
      )}
    </div>
  )
}
